module.exports = __webpack_public_path__ + "static/media/heather.a0ab22a4.png";